module.exports = __webpack_public_path__ + "img/close.de616717.png";